import { Box, CircularProgress, styled, Typography } from "@mui/material";

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "4px",
  minWidth: 200,
}));

const Label = styled(Typography)(({ theme }) => ({
  fontSize: "0.9rem",
  color: theme.palette.text.secondary,
  letterSpacing: "0.05em",
}));

const Value = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  wordBreak: "break-all",
}));

const DetailItem = ({ label, value, isLoading }) => {
  const displayValue =
    value && typeof value === "object" ? "-" : value || "-";

  return (
    <Root>
      <Label>{label}</Label>
      {isLoading ? (
        <CircularProgress size={14} thickness={4} />
      ) : (
        <Value>{displayValue}</Value>
      )}
    </Root>
  );
};

export default DetailItem;